export const formatAddress = (address) =>
  `${address?.streetAddress || ''} ${address?.zipCode || ''} ${
    address?.city || ''
  }`.trim() || 'N/A';

export const formatFullName = ({ firstName, lastName }) =>
  `${firstName || ''} ${lastName || ''}`.trim() || 'N/A';
